import { useQuery } from "@tanstack/react-query"
import { marketplaceCapabilitiesQuery } from "../lib/marketplaceCapabilitiesQuery"

export function useMarketplaceCapabilitiesQuery(
  ...args: Parameters<typeof marketplaceCapabilitiesQuery>
) {
  return useQuery(marketplaceCapabilitiesQuery(...args))
}
